import api, { unwrap } from './client';

/* Plan des ventes — document JSON par client, persisté côté serveur.
   Il ne vivait que dans le navigateur : saisie perdue en changeant de poste, et
   illisible par le serveur qui calcule le prévisionnel. */

export const getSalesPlan = (tenantId) => unwrap(api.get(`/sales-plan/${tenantId}`));
export const putSalesPlan = (tenantId, data) => unwrap(api.put(`/sales-plan/${tenantId}`, { data }));

/* Sauvegarde PARTIELLE — chaque page n'écrit QUE sa section.
   Le document est partagé (Plan produits · Plan services · Plan des ventes) et
   chaque page en poussait la COPIE ENTIÈRE depuis sa mémoire locale : une page
   dont la copie était périmée effaçait les cards des autres (cards produits
   disparues, 2026-08-16). On relit donc le document serveur et on n'y remplace
   que les clés possédées. */
export const putSalesPlanSection = async (tenantId, model, ownedKeys, computeFn) => {
  const r = await getSalesPlan(tenantId);
  if (r?.error) return r;                       // lecture KO → on n'écrit RIEN
  const base = (r?.data?.data && typeof r.data.data === 'object') ? r.data.data : {};
  const merged = { ...base };
  ownedKeys.forEach((k) => { merged[k] = model[k]; });
  // Cadrage (année courante, horizon, mois clos) : porté par la page active.
  ['currentYear', 'nbYears', 'closedMonths'].forEach((k) => {
    if (model[k] != null) merged[k] = model[k];
  });
  if (computeFn) merged.computed = computeFn(merged);
  return putSalesPlan(tenantId, merged);
};
